<template lang="html">
  <span
    class="eca-avatar"
    :class="['eca-avatar--' + size]"
    :style="customStyle"
  >
    <div class="eca-avatar__content">
      <div class="eca-avatar__initials">{{ initials }}</div>
      <app-img
        v-if="picture"
        :src="picture"
        :original="original"
        :width="width"
        :height="height"
        class="eca-avatar__img"
      />
    </div>
  </span>
</template>

<script>
// https://stackoverflow.com/a/3426956 for text to hash to rgb
import AppImg from '@/components/general/Img.vue';

function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}
function intToRGB(i) {
  // eslint-disable-next-line no-bitwise
  const c = (i & 0x00ffffff).toString(16).toUpperCase();
  return '00000'.substring(0, 6 - c.length) + c;
}
function textColor(text) {
  return intToRGB(hashCode(text));
}
export default {
  components: {
    AppImg,
  },
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    picture: {
      type: String,
      required: false,
      default: null,
    },
    width: {
      type: Number,
      required: false,
      default: null,
    },
    height: {
      type: Number,
      required: false,
      default: null,
    },
    original: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
      validator(x) {
        return ['small', 'medium', 'large'].indexOf(x) > -1;
      },
    },
  },
  computed: {
    customStyle() {
      const color = this.name
        ? `#${textColor(this.name)}`
        : 'var(--eca-primary-base)';
      return `--eca-avatar-color: ${color}`;
    },
    initials() {
      const initials = (this.name && this.name.match(/\b\w/g)) || [];
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    },
  },
};
</script>

<style lang="css" scoped>
.eca-avatar {
  line-height: --eca-avatar-size;
  --eca-avatar-color: var(--cs-primary-base);
  --eca-avatar-size: 35px;
  --eca-avatar-font-size: 12px;
}
.eca-avatar__content {
  display: block;
  position: relative;
  height: var(--eca-avatar-size);
  width: var(--eca-avatar-size);
  line-height: 1;
  border-radius: 50%;
  box-sizing: border-box;
  overflow: hidden;
  align-items: center;
  border: 2px solid #fff;
}
.eca-avatar--small {
  --eca-avatar-size: 35px;
  --eca-avatar-font-size: 12px;
}
.eca-avatar--medium {
  --eca-avatar-size: 55px;
  --eca-avatar-font-size: 16px;
}
.eca-avatar--large {
  --eca-avatar-size: 85px;
  --eca-avatar-font-size: 22px;
}
.eca-avatar__img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  objeeca-fit: cover;
  width: 100%;
  height: 100%;
}
.eca-avatar__initials {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: var(--cs-gray-00);
  font-weight: var(--cs-font-weight-bold);
  font-size: var(--eca-avatar-font-size);
  background-color: var(--eca-avatar-color);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
</style>
